import { resizeImage, merchantisePantoneColor } from "../image"; 

export const getImprintProcessValueForHolographicTemp = (variableAttributes) => {
  var value = null;
  if (variableAttributes) {
      variableAttributes.forEach(function (str) {
          if (str.split(':')[0] === 'Deco Process 1') {
              value = str.split(':')[1];
          }
      });
  }
  return value;
};

export const getImprintInfo = (customizationInfo, customizationType) => {
  const imprintColorName = customizationType === 'DIM' ? customizationInfo?.imprintColor?.Name
      : customizationType === 'DIY' ? customizationInfo.imprintColor[0]?.Name ?? 'Assorted'
          : '';
  
  if(imprintColorName === "") return null;

  const imprintColorInfo = merchantisePantoneColor(imprintColorName);
  const imprintColorValue = imprintColorInfo.rgb === 'Assorted' ? '<span class="assorted">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>'
      : '<span style="border:1px solid black;background-color:' + imprintColorInfo.rgb + ';">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>';

     
  return {
      attribute: 'shopping_logic.imprint_color',
      value: imprintColorValue + ' ' + imprintColorInfo.displayName
  }
};

